import * as angular from "angular";
import datetimeControl from "./datetime-control";
import template from "./date-control.html";

export default angular.module("vesl.extensions.json-schema.date-control", [datetimeControl])
	.component("jsonSchemaDateControl", {
		template,
		bindings: { control: "<" }
	})
	.name;
